import script from "./TermsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsPage.vue?vue&type=script&setup=true&lang=ts"

import "./TermsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__